import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { positiveInt32Schema } from './schemas/positiveInt32Schema';

export interface IPatientInvoiceServicePriceAddEditValidated {
    endDate?: string | Date | null;
    id?: string;
    price: number;
    serviceId: string;
    startDate: string | Date;
}

const patientInvoiceServicePriceAddEdit = Koi.object({
    endDate: Koi.koi().date().endDate().allow(null).optional(),
    id: Koi.string().uuid().optional(),
    price: positiveInt32Schema.required(),
    serviceId: Koi.string().uuid().required(),
    startDate: Koi.koi().date().required(),
}).options({ convert: false, presence: 'required' });

export const patientInvoiceServicePriceAddEditSchema: ISchemaContainer<IPatientInvoiceServicePriceAddEditValidated> = {
    schema: patientInvoiceServicePriceAddEdit,
};
